import { render } from "./TurmoilAgenda.vue?vue&type=template&id=6ab92ed9&ts=true"
import script from "./TurmoilAgenda.vue?vue&type=script&lang=ts"
export * from "./TurmoilAgenda.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__